import styled, { withTheme } from 'styled-components'
import { Relative } from '../../../utils/style'

const SearchGroupHeading = styled(Relative)`
  background: ${(props) => props.theme.colors.blue_light};
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.blue};
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: 0.02em;

  & > span {
    color: ${(props) => props.theme.colors.grey_light};
    font-weight: 400;
    text-transform: none;
  }
`

export default withTheme(SearchGroupHeading)
